var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { changeUserStatusRequest, createUserRequest, deleteUserRequest, editUserRequest, resetUserPasswordRequest, } from "../../api/api";
function useUserActions() {
    const createUser = (userName, userDescription, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield createUserRequest(userName, userDescription);
            if (callback)
                callback(response.data);
            toast.success(__("User created successfully", "quicktasker"));
        }
        catch (error) {
            console.error(error);
            toast.error(__("User creation failed. Please try again", "quicktasker"));
        }
    });
    const editUser = (user, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield editUserRequest(user);
            if (callback)
                callback(response.data);
            toast.success(__("User edited successfully", "quicktasker"));
        }
        catch (error) {
            console.error(error);
            toast.error(__("User edit failed. Please try again", "quicktasker"));
        }
    });
    const changeUserStatus = (userId, status, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield changeUserStatusRequest(userId, status);
            if (callback)
                callback(response.data);
            toast.success(__("User status changed successfully", "quicktasker"));
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to change user status. Please try again", "quicktasker"));
        }
    });
    const deleteUser = (userId, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield deleteUserRequest(userId);
            if (callback)
                callback(userId);
            toast.success(__("User deleted successfully", "quicktasker"));
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to delete user. Please try again", "quicktasker"));
        }
    });
    const resetUserPassword = (userId, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield resetUserPasswordRequest(userId);
            if (callback)
                callback(userId);
            toast.success(__("User password reset successfully", "quicktasker"));
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to reset user password. Please try again", "quicktasker"));
        }
    });
    return {
        createUser,
        editUser,
        changeUserStatus,
        deleteUser,
        resetUserPassword,
    };
}
export { useUserActions };
